/* eslint-disable import/no-anonymous-default-export */
import client from "./Client";

const getStaffData = () => client.get(`/staff/details`);

export default {
  getStaffData,
};
